import React, { useRef, useEffect } from 'react';
import Layout from '../../components/Layout';
import Slider from './pages/slider';
import AboutUs from './pages/AboutUs';
import Menus from './pages/menus';
import ContactUs from './pages/contactus';
import BookNow from './pages/booknow';
import CustomerGalleryPage from './pages/Gallery';

const LandingPage = () => {

    const homeRef = useRef(null);
    const aboutRef = useRef(null);
    const galleryRef = useRef(null);
    const contactRef = useRef(null);
    const bookNowRef = useRef(null);
    const menusRef = useRef(null);


    const scrollToSection = (sectionRef) => {
        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };


    const scrollFunctions = {
        scrollToHome: () => scrollToSection(homeRef),
        scrollToAbout: () => scrollToSection(aboutRef),
        scrollToGallery: () => scrollToSection(galleryRef),
        scrollToContact: () => scrollToSection(contactRef),
        scrollToBookNow: () => scrollToSection(bookNowRef),
        scrollToMenus: () => scrollToSection(menusRef),
    };


    useEffect(() => {

        if (!('scrollBehavior' in document.documentElement.style)) {

            import('smoothscroll-polyfill').then(module => {
                module.polyfill();
            });
        }
    }, []);

    return (
        <Layout isLanding={true} scrollFunctions={scrollFunctions}>

            <div ref={homeRef} id="home">
                <Slider onGalleryPress={scrollFunctions.scrollToGallery}
                    onBookNowPress={scrollFunctions.scrollToBookNow}
                    onContactPress={scrollFunctions.scrollToContact}
                />
            </div>

            <div ref={aboutRef} id="about">
                <AboutUs onGalleryPress={scrollFunctions.scrollToGallery} />
            </div>

            <div ref={menusRef} id="menus">
                <Menus />
            </div>


            <div ref={galleryRef} id="gallery">
                <CustomerGalleryPage />
            </div>


            <div ref={contactRef} id="contact">
                <ContactUs />
            </div>


            <div ref={bookNowRef} id="book-now">
                <BookNow />
            </div>
        </Layout>
    );
};

export default LandingPage;